import GenericRequest, { METHOD_GET } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export default class CompanyRequest extends GenericRequest {

    constructor(id) {
        super(METHOD_GET, RouterUtils.generateRoute(ApiEndpoints.COMPANY_ID, { id: id }));
    }

}



// WEBPACK FOOTER //
// ./src/app/company/ws/CompanyRequest.js